import { NgModule } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { HeaderComponent } from './shared/layout/header/header.component';
import { SidebarComponent } from './shared/layout/sidebar/sidebar.component';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';
import { LoginComponent } from './core/authentication/login/login.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ResetPasswordComponent } from './core/authentication/reset-password/reset-password.component';
import { FirstLoginPasswordComponent } from './core/authentication/first-login-password/first-login-password.component';
import { UsersModule } from './features/users/users.module';
import { SharedModule } from './shared/shared.module';
import { ChannelsModule } from './features/channels/channels.module';
import { RolesModule } from './features/roles/roles.module';
import { ForbiddenPageComponent } from './shared/components/forbidden-page/forbidden-page.component';
import { HasPermissionDirective } from './core/authentication/directives/has-permission.directive';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        SidebarComponent,
        MainLayoutComponent,
        LoginComponent,
        ResetPasswordComponent,
        FirstLoginPasswordComponent,
        ForbiddenPageComponent
    ],
    imports: [
        BrowserModule,
        RouterOutlet,
        RouterModule,
        ReactiveFormsModule,
        SharedModule,
        UsersModule,
        ChannelsModule,
        RolesModule,
        HasPermissionDirective
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
